import { createFileRoute } from '@tanstack/react-router';
import { PresentationPresenterPage } from '../features/presentations/presentation-presenter-page';
export const Route = createFileRoute(
  '/manage/$companySlug/projects/$projectId/presentations/$presentationId/present/$slideId',
)({ component: Page });
function Page() {
  return <PresentationPresenterPage {...Route.useParams()} />;
}
